var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "350" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-date-picker", {
                    attrs: { label: _vm.$ct("common.date.date"), fancy: "" },
                    model: {
                      value: _vm.state.selectedRow.DeliveryDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.state.selectedRow, "DeliveryDate", $$v)
                      },
                      expression: "state.selectedRow.DeliveryDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.confirmText))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }